<template>
  <div id="bidnotice" class="zl-form-group">
    <div class="zl-form-group-header">
      <div class="zl-form-group-title">
        <i class="title-decorate iconfont icon-decorate" />
        竞价须知
      </div>
    </div>
    <div class="zl-form-group-form notice-bottom">
      <el-row :gutter="24">
        <el-col :span="24">
          <Tinymce v-if="!isDisplay" v-model="form.biddingNotice" />
          <div v-else v-html="form.biddingNotice" />
        </el-col>
      </el-row>
    </div>
  </div>

</template>
<script>
import Tinymce from '@/components/tinymce/index.js'
export default {
  components: {
    Tinymce
  },
  props: {
    form: {
      type: Object,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isDisplay: {
      type: Boolean,
      default: false
    }
  }

}
</script>
<style lang="scss" scoped>
@import './common.scss';
.notice-bottom{
  padding-bottom: 18px;

}

</style>
